import { render, staticRenderFns } from "./material.vue?vue&type=template&id=7d1b5b04&scoped=true"
import script from "./material.vue?vue&type=script&lang=js"
export * from "./material.vue?vue&type=script&lang=js"
import style0 from "./material.vue?vue&type=style&index=0&id=7d1b5b04&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1b5b04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zhenzhaopin\\xxh-zhaopin-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d1b5b04')) {
      api.createRecord('7d1b5b04', component.options)
    } else {
      api.reload('7d1b5b04', component.options)
    }
    module.hot.accept("./material.vue?vue&type=template&id=7d1b5b04&scoped=true", function () {
      api.rerender('7d1b5b04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/costPlatform/components/widgets/basic_text/material.vue"
export default component.exports